import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
const MAIN_PRODUCT_URL = 'https://www.mentefluir.com/cart/44741027889199:1';
const ORDER_BUMP_URL = 'https://www.mentefluir.com/cart/44741027889199:1,44977860968495:1';
interface CTAProps {
  orderBumpChecked?: boolean;
}
export function CTA({
  orderBumpChecked = false
}: CTAProps) {
  const {
    t
  } = useLanguage();
  const purchaseUrl = orderBumpChecked ? ORDER_BUMP_URL : MAIN_PRODUCT_URL;
  return <section className="mt-12 md:mt-20 text-center" data-id="element-4">
      <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#2C4A3E] mb-8 md:mb-10" data-id="element-5">
        {t.cta.title}
      </h2>

      {/* Horizontal check cards */}
      <div className="space-y-3 md:space-y-4 max-w-2xl mx-auto mb-8 md:mb-10" data-id="element-6">
        {/* First 2 items from translations */}
        {t.cta.items.slice(0, 2).map((item, index) => <div key={index} className="flex items-center gap-4 bg-gradient-to-br from-[#2C4A3E] to-[#1F3329] border border-[#D4A574]/30 rounded-lg px-5 md:px-6 py-4 md:py-5 text-left" data-id="element-7">
            <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-[#D4A574]/20 flex items-center justify-center" data-id="element-8">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 md:w-5 md:h-5" viewBox="0 0 24 24" fill="none" stroke="#E8B86D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-9">
                <polyline points="20 6 9 17 4 12" data-id="element-10" />
              </svg>
            </div>
            <span className="text-[#FBF8F3] text-base md:text-lg leading-snug" data-id="element-11">
              {item}
            </span>
          </div>)}

        {/* Third card — value framing */}
        <div className="flex items-center gap-4 bg-gradient-to-br from-[#2C4A3E] to-[#1F3329] border border-[#D4A574]/30 rounded-lg px-5 md:px-6 py-4 md:py-5 text-left" data-id="element-12">
          <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-[#D4A574]/20 flex items-center justify-center" data-id="element-13">
            <span className="text-[#E8B86D] font-bold text-base md:text-lg leading-none" data-id="element-14">
              $
            </span>
          </div>
          <span className="text-[#FBF8F3] text-base md:text-lg leading-snug" data-id="element-15">
            Hoy inviertes menos de lo que cuesta una cena…y cambias un patrón
            que puede costarte miles de dólares al año
          </span>
        </div>

        {/* Remaining items (index 2+) */}
        {t.cta.items.slice(2).map((item, index) => <div key={`rest-${index}`} className="flex items-center gap-4 bg-gradient-to-br from-[#2C4A3E] to-[#1F3329] border border-[#D4A574]/30 rounded-lg px-5 md:px-6 py-4 md:py-5 text-left" data-id="element-16">
            <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-[#D4A574]/20 flex items-center justify-center" data-id="element-17">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 md:w-5 md:h-5" viewBox="0 0 24 24" fill="none" stroke="#E8B86D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-18">
                <polyline points="20 6 9 17 4 12" data-id="element-19" />
              </svg>
            </div>
            <span className="text-[#FBF8F3] text-base md:text-lg leading-snug" data-id="element-20">
              {item}
            </span>
          </div>)}
      </div>

      {/* Subtitle */}
      <p className="text-xl md:text-2xl font-serif text-[#8B4513] mb-7 md:mb-9 italic px-2" data-id="element-21">
        {t.cta.subtitle}
      </p>

      {/* CTA Button */}
      <motion.a href="#oferta" whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.98
    }} className="inline-block px-8 md:px-12 py-4 md:py-5 rounded-full text-lg md:text-xl font-semibold transition-all duration-300 text-white" style={{
      background: '#E4574F',
      border: '1px solid rgba(255, 140, 130, 0.5)'
    }} data-id="element-22">
        {t.cta.button}
      </motion.a>

      {/* Closing */}
      <p className="text-[#4A4A4A] mt-6 md:mt-8 text-base md:text-lg" data-id="element-23">
        {t.cta.closing}
      </p>
    </section>;
}